import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Api from '~/api';
import { TributeCategory } from '~/types/common';
import { connect } from 'react-redux';
import PreNeedPopup from '~/components/PreNeedPopup';
import { Button } from './preNeedButton.styles';
const PreNeedButton = ({ page, eventStatus }) => {
    const [isPreNeedFormOpen, setIsPreNeedFormOpen] = useState(false);
    const handlePreNeedButtonClick = () => {
        setIsPreNeedFormOpen(true);
        Api.Analytics.preNeedClick(TributeCategory.prePlanning, page, eventStatus);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { id: "prePlanningBtn", onClick: handlePreNeedButtonClick, children: "Funeral Pre-planning" }), _jsx(PreNeedPopup, { open: isPreNeedFormOpen, setOpen: setIsPreNeedFormOpen, page: page })] }));
};
const mapStateToProps = (state) => ({
    eventStatus: state.event.data.status,
});
export default connect(mapStateToProps)(PreNeedButton);
